import { render, staticRenderFns } from "./BusinessBody.vue?vue&type=template&id=4f37d88c"
import script from "./BusinessBody.vue?vue&type=script&lang=js"
export * from "./BusinessBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports